import { EditorState } from 'draft-js';
export class EditorStateModel {
        public index: number;
        public editorState: EditorState;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/EditorStateModel.ts